/* Successful PDP interactions only. Never grant consent or replay denied events. */
(function () {
  'use strict';
  if (window.__evPdpAnalyticsBound) return;
  window.__evPdpAnalyticsBound = true;

  function track(name, detail = {}) {
    try {
      if (window.EssentialsVault?.analytics?.isInternalContext?.()) return;
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      if (typeof window.clarity !== 'function') return;
      const tags = {
        pdp_product_handle: detail.handle,
        pdp_product_id: detail.productId,
        pdp_variant_id: detail.variantId,
        pdp_color_from: detail.from,
        pdp_color_to: detail.colorName,
        pdp_navigation_source: detail.source,
        pdp_size: detail.size,
      };
      Object.entries(tags).forEach(([key, value]) => {
        if (value !== undefined && value !== null) window.clarity('set', key, String(value));
      });
      window.clarity('event', name);
    } catch (_) {
      // Tracking must never block product selection, dialogs or cart actions.
    }
  }

  document.addEventListener('pdp:color-change', event => {
    const detail = event.detail || {};
    if (detail.source === 'history' && detail.from === detail.colorName) return;
    track('pdp_color_change', detail);
  });
  document.addEventListener('pdp:size-guide-open', event => track('pdp_size_guide_open', event.detail));
  document.addEventListener('pdp:color-error', () => track('pdp_color_change_error'));
})();
